import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mouvements-stock',
  templateUrl: './mouvements-stock.component.html'
})
export class MouvementsStockComponent implements OnInit {
  boutiques = [
    { id: 1, nom: 'Boutique A' },
    { id: 2, nom: 'Boutique B' },
  ];

  articles = [
    { id: 101, nom: 'Article 1', qteTotal: 20, qteTransfert: 0 },
    { id: 101, nom: 'Article 2', qteTotal: 20, qteTransfert: 0 },
    { id: 102, nom: 'Article 3', qteTotal: 10, qteTransfert: 0 },
  ];

  sourceBoutique: any;
  destinationBoutique: any;

  ngOnInit(): void {
    // TODO : charger boutiques & articles dynamiquement
  }

  envoyerTransfert() {
    const transfert = {
      source: this.sourceBoutique.id,
      destination: this.destinationBoutique.id,
      articles: this.articles
        .filter(a => a.qteTransfert > 0)
        .map(a => ({ id: a.id, qte: a.qteTransfert }))
    };

    console.log('Envoi du transfert', transfert);
    // Appel du service ici
  }
}
